export default "__VITE_ASSET__d5377d21__"